import { OPS_RAIL } from 'lib/opsSections'
import type { RailConfig } from 'lib/railSections'
import { SETTINGS_RAIL } from 'lib/settingsSections'

/**
 * Every grouped-sidebar row that opens a page with a rail, in the order a path is checked
 * against them: Settings first, so the Ops pages under /settings fall through to Ops only when no
 * Settings section is active there.
 */
export const PAGE_RAILS: RailConfig[] = [SETTINGS_RAIL, OPS_RAIL]
